/**
 * @generated SignedSource<<f62a1b3903c7538c9783957e13f83304>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type emailTemplateEdit_Query$variables = {
  id: string;
};
export type emailTemplateEdit_Query$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"emailTemplateEdit_EmailTemplateFragment">;
  } | null;
};
export type emailTemplateEdit_Query = {
  response: emailTemplateEdit_Query$data;
  variables: emailTemplateEdit_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "emailTemplateEdit_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "emailTemplateEdit_EmailTemplateFragment"
              }
            ],
            "type": "PersonalizedEmailTemplate",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "emailTemplateEdit_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EmailTemplate",
                "kind": "LinkedField",
                "name": "template",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subject",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "previewText",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "body",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "variables",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "PersonalizedEmailTemplate",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dfabc5ee5ffec236ac2eef437885d213",
    "id": null,
    "metadata": {},
    "name": "emailTemplateEdit_Query",
    "operationKind": "query",
    "text": "query emailTemplateEdit_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on PersonalizedEmailTemplate {\n      ...emailTemplateEdit_EmailTemplateFragment\n    }\n    id\n  }\n}\n\nfragment emailTemplateEdit_EmailTemplateFragment on PersonalizedEmailTemplate {\n  id\n  template {\n    key\n    subject\n    previewText\n    body\n    variables\n  }\n}\n"
  }
};
})();

(node as any).hash = "1b22c2756a68c330b4660afb6cbeb414";

export default node;
